import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { getVisitorEmail } from './visitorEmail';

export { getVisitorEmail };

/**
 * Javni endpoint — ne šalje Authorization (radi i za neregistrovane posetioce).
 */
export function trackTutorialEvent({ event, source, tutorialId = '', title = '', path, kind = '' }) {
  if (typeof window === 'undefined') return;

  let trackingId = '';
  try {
    trackingId = sessionStorage.getItem('analytics_tracking_id') || '';
    if (!trackingId) {
      trackingId = `track_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('analytics_tracking_id', trackingId);
    }
  } catch {
    // ignore
  }

  const email = getVisitorEmail();

  const payload = {
    event,
    source,
    tutorialId: String(tutorialId || '').slice(0, 256),
    title: String(title || '').slice(0, 512),
    path: String(path || window.location.pathname || '').slice(0, 1024),
    kind: String(kind || '').slice(0, 32),
    trackingId: String(trackingId || '').slice(0, 128),
    email: email || undefined
  };

  axios
    .post(`${API_BASE_URL}/api/analytics/track/tutorial-event`, payload, {
      headers: { 'Content-Type': 'application/json' }
    })
    .catch(() => {});
}
